import { motion } from "framer-motion";
import AppStoreButton from "./AppStoreButton";

const CtaBanner = () => (
  <section className="relative px-6 py-24 sm:py-32" data-testid="download-cta-section">
    <motion.div
      initial={{ opacity: 0, y: 48 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="relative mx-auto max-w-4xl overflow-hidden rounded-[2.5rem] border border-crimson/25 bg-surface px-8 py-16 text-center sm:py-20"
    >
      <div className="pointer-events-none absolute -top-24 left-1/2 h-64 w-[130%] -translate-x-1/2 rounded-full bg-crimson/20 blur-[110px]" />
      <div className="noise-overlay" />
      <p className="relative font-mono text-xs font-medium uppercase tracking-[0.25em] text-crimson">
        Now Available
      </p>
      <h2 className="relative mt-5 font-heading text-2xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
        Experience Michael C Streamline today
      </h2>
      <p className="relative mx-auto mt-5 max-w-xl text-base leading-relaxed text-slate-400">
        Download free on the App Store and step into a new era of streaming
        and social connection on iOS.
      </p>
      <div className="relative mt-10 flex justify-center">
        <AppStoreButton variant="crimson" size="lg" testId="cta-download-button" />
      </div>
    </motion.div>
  </section>
);

export default CtaBanner;
